module.exports = __webpack_public_path__ + "img/uz.f71a299e.svg";